export const CommandModelGrant = ['admin', 'user']
